export default __webpack_public_path__ + "static/media/parallax-bg37.5103e274.jpg";